import axios from "axios";
import { HeadersUtil } from "../../utils/headersUtil";

export class TccoFileService {
  private static _tccoFileService: TccoFileService;

  public static getInstance(): TccoFileService {
    if (!TccoFileService._tccoFileService) {
      TccoFileService._tccoFileService = new TccoFileService();
    }
    return TccoFileService._tccoFileService;
  }

  public saveFile(file: any) {
    const url = process.env.REACT_APP_MAIN_URL + "/common/file-service/saveFile";

    const formData = new FormData();
    formData.append("multipartFile", file);

    return axios.post(url, formData, {
      headers: HeadersUtil.getHeadersAuthFormData(),
    });
  }
}
